import { lazy } from 'react';

const RELOAD_FLAG = 'exo-chunk-reload';

function readFlag() {
  try {
    return sessionStorage.getItem(RELOAD_FLAG);
  } catch {
    return '1'; // no storage: never reload automatically
  }
}

function writeFlag(value) {
  try {
    if (value) sessionStorage.setItem(RELOAD_FLAG, value);
    else sessionStorage.removeItem(RELOAD_FLAG);
  } catch {
    // ignore
  }
}

/**
 * A page that is loaded when it is first opened instead of being part of the
 * startup bundle (which phones have to download, parse and compile first).
 *
 *   const Invoices = lazyPage(() => import('./scenes/invoices'));
 *   const { ShowInvoice } = …  →  lazyPage(() => import('…/ShowInvoice'), 'ShowInvoice')
 *
 * After a deploy the old chunk files are gone; a failed load then reloads the
 * app once to get the new version. Offline, the error goes to the
 * PageErrorBoundary, which offers a retry.
 */
export function lazyPage(factory, exportName = 'default') {
  return lazy(() =>
    factory()
      .then((module) => {
        writeFlag(null);
        return { default: module[exportName] };
      })
      .catch((error) => {
        if (navigator.onLine !== false && !readFlag()) {
          writeFlag('1');
          window.location.reload();
          // keep suspending until the reload happens
          return new Promise(() => {});
        }
        throw error;
      }),
  );
}
